<template>
  <div>
    <i-col span="24">
      <table
        v-for="(it , index) in tb1"
        :key="index+'other1_1'"
        class="left TB_COLLAPSE"
        :class="[cloce]"
        width="12.5%"
      >
        <thead>
          <th width="30%">{{$route.meta.title}}</th>
          <th width="70%">賠率占成</th>
        </thead>
        <tbody>
          <tr v-for="(item, key) in it" :key="key+'other1_2'" class="tc">
            <th :class="'pc'+item.colour">
              <h4>{{ item.name }}</h4>
            </th>
            <td :class="{'isstop0': item.isstop == 2 || item.isstop == 0 }">
              <table-adjust-odds :table="item" @go_live_show_bridge="go_live_show_bridge"></table-adjust-odds>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <template v-if="getgameid != 15">
        <table
          v-for="(it , index) in tb2"
          :key="index+'other2_1'"
          class="left TB_COLLAPSE"
          :class="[cloce]"
          width="12.5%"
        >
          <thead>
            <th width="30%">{{$route.meta.title}}</th>
            <th width="70%">賠率占成</th>
          </thead>
          <tbody>
            <tr v-for="(item, key) in it" :key="key+'other2_2'" class="tc">
              <th :class="item.colour">
                <h4>{{ item.name }}</h4>
              </th>
              <td :class="{'isstop0': item.isstop == 2 || item.isstop == 0 }">
                <table-adjust-odds
                  :table="item"
                  @go_live_show_bridge="go_live_show_bridge"
                  :addbetcal="false"
                ></table-adjust-odds>
              </td>
            </tr>
          </tbody>
        </table>
      </template> -->
    </i-col>
  </div>
</template>

<script>
import { Utile } from 'utils'
import { mapGetters, mapState, mapActions } from "vuex";
import checkpath from "./mixins/checkPath.js";
import liveshowSixmark from '@/mixins/liveshow-sixmark.js'
export default {
  name: "liveshow-other",
  mixins: [checkpath, liveshowSixmark],
  data () {
    return {
      tb1: [],
      tb2: []
    };
  },
  created () {
    this.readyaxiso();
  },
  computed: {
    ...mapGetters(["getliveshow", "getgameid"]),
    KeyName () {
      return this.liveshowPath ? 'supodod' : 'linksupodod'
    }
  },
  watch: {
    "getliveshow.chgbaco" (val) {
      this.readyaxiso();
    },
    "$route.meta.page" (val) {
      this.readyaxiso()
    }
  },
  methods: {
    async get_tb1 () {
      try {
        const meta = this.$route.meta
        const obj = {
          gameid: this.getgameid,
          page: 16,
          odd: 12,
          baco: this.getliveshow.chgbaco,
          site: this.getliveshow.siteSelect
        }
        if (this.getliveshow.siteSelect == '') {
          this.tb1 = []
          return
        }
        const res = await this.$axios.liveshow[this.KeyName](obj);
        if ('status' in res && res.status === 0) return
        this.IsstopColor(res)
        const array = res.map(it => (it.clas = 0, it));
        const zodic = array.filter(item => item.odddtl == 39)
        const reoebs = [this.$t('system.red'), this.$t('system.blue'), this.$t('system.green')].reduce((arry, it) => {
          [`${it}单`, `${it}双`, `${it}大`, `${it}小`].forEach(item => {
            arry.push(array.find(its => its.name == item))
          })
          return arry
        }, [])
        let twoSideOddlt = []

        for (let index = 1; index < 7; index++) {
          let filterData = [`${index}单`, `${index}双`, `${index}大`, `${index}小`, `${index}合单`, `${index}合双`, `${index}合大`, `${index}合小`, `${index}紅`, `${index}藍`, `${index}綠`].reduce((arry, na) => {
            arry.push(array.find(it => it.name.includes(na)))
            return arry
          }, [])
          twoSideOddlt.push(filterData)
        }
        this.tb1 = [...twoSideOddlt, zodic, reoebs]
        // this.tb1 = Utile.chunk(array, 3);
      } catch (error) {
        console.log(error + "liveshow_other1_1_get_error了喔！");
      }
    },
    async get_tb2 () {
      try {
        const meta = this.$route.meta
        const obj = {
          gameid: this.getgameid,
          page: 17,
          odd: 9,
          baco: this.getliveshow.chgbaco,
          site: this.getliveshow.siteSelect
        }
        if (this.getliveshow.siteSelect == '') {
          this.tb2 = []
          return
        }
        const res = await this.$axios.liveshow[this.KeyName](obj);
        this.IsstopColor(res)
        const array = res.map(it => (it.clas = 1, it));
        this.tb2 = Utile.chunk(array, 4);
      } catch (error) {
        console.error("liveshow_other1_2_get_error了喔！");
      }
    },
    readyaxiso () {
      if (!this.$route.name.includes('other')) return
      this.get_tb1();
      // this.get_tb2();
    },
    go_live_show_bridge () {
      this.$emit("refresh");
    }
  }
};
</script>